import React, { useState } from 'react'
import { Box, Button, Typography } from '@material-ui/core'
import { ChevronLeft, ChevronRight } from 'react-feather'
import { isEmpty } from 'lodash'

import useFetch from 'hooks/useFetch'

import { LoadingFeedback } from 'components'
import { LessonSidebar } from 'views/Training/LessonContent/components'

import * as service from 'service'
import useStyles from './styles'
import courseConstants from 'constants/course'

const ExerciseView = ({ lesson, courseModules }) => {
  const classes = useStyles()
  const [currentIndex, setCurrentIndex] = useState(0)

  const { response, isLoading } = useFetch(
    service.dponet.trainingCourse.exercisePreview,
    { exerciseId: lesson?.entityId },
    [lesson?.entityId],
  )

  const { LETTERS } = courseConstants

  const exercise = isLoading ? null : response?.data?.exercise
  const questions = exercise?.questions || []
  const currentQuestion = questions[currentIndex]
  const isFirstQuestion = currentIndex === 0
  const isLastQuestion = currentIndex === questions.length - 1

  if (!isLoading && isEmpty(questions)) return null

  return (
    <Box className={classes.body}>
      <LoadingFeedback open={isLoading} />
      <Box className={classes.mainContent}>
        {!isLoading && currentQuestion && (
          <>
            <Box className={classes.progressHeader}>
              <Typography className={classes.progressLabel}>
                Questão {currentIndex + 1} de {questions.length}
              </Typography>
              <Box className={classes.stepsRow}>
                {questions.map((question, index) => (
                  <Box
                    key={question?.id}
                    className={`${classes.step}${
                      index === currentIndex ? ` ${classes.stepActive}` : ''
                    }`}
                  />
                ))}
              </Box>
            </Box>

            <Box className={classes.questionCard}>
              <Typography className={classes.questionStatement}>
                {currentIndex + 1}. {currentQuestion?.statement}
              </Typography>

              {(currentQuestion?.correctCount ?? 0) > 1 && (
                <Typography
                  className={classes.multipleCorrectHint}
                  color="textSecondary"
                >
                  Selecione {currentQuestion.correctCount} alternativas corretas
                </Typography>
              )}

              <Box className={classes.alternativesList}>
                {currentQuestion?.alternatives?.map((alternative, index) => (
                  <Box key={alternative?.id} className={classes.alternativeRow}>
                    <Box className={classes.alternativeLetter}>
                      {LETTERS[index]}
                    </Box>
                    <Typography className={classes.alternativeContent}>
                      {alternative?.content}
                    </Typography>
                  </Box>
                ))}
              </Box>

              <Box className={classes.navigation}>
                <Button
                  variant="text"
                  size="small"
                  startIcon={<ChevronLeft />}
                  onClick={() => setCurrentIndex((previous) => previous - 1)}
                  disabled={isFirstQuestion}
                  className={classes.prevButton}
                >
                  Anterior
                </Button>
                <Button
                  variant="contained"
                  size="small"
                  endIcon={<ChevronRight />}
                  onClick={() => setCurrentIndex((previous) => previous + 1)}
                  disabled={isLastQuestion}
                  className={classes.nextButton}
                >
                  Próxima pergunta
                </Button>
              </Box>
            </Box>
          </>
        )}
      </Box>
      <LessonSidebar
        modules={courseModules}
        activeLessonId={lesson?.id}
        portalToken={null}
        courseId={null}
        history={null}
        disabled
      />
    </Box>
  )
}

export default ExerciseView
